// Gelen Sipariş (B2B) detay penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'documents.incomingOrderDetail';

export const incomingOrderDetailGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Gelen sipariş nasıl işlenir?'),
  intro: t(`${G}.intro`, 'Bu pencerede tedarikçinizden gelen siparişin kalemlerini kontrol eder, teslim aldığınız malı onaylar ve siparişi alış faturasına çevirirsiniz. Pencere, siparişin aşamasına göre uygun sekmede açılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Sipariş bilgisi ve durum'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Sekme içeriği'),
    footer: t(`${G}.regions.footer`, 'Kapat / Onayla'),
  },
  navItems: [
    t(`${G}.nav.order`, 'Sipariş'),
    t(`${G}.nav.delivery`, 'Teslim'),
    t(`${G}.nav.invoice`, 'Fatura'),
  ],
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Siparişin durumunu okuyun'),
      text: t(`${G}.s1.text`, 'Başlıkta satıcı firma, sipariş no, tarih ve şube yazar. Altındaki etiketler siparişin durumunu (ör. Kargoda, Teslim Edildi), teslimi ("Teslim bekliyor", "Teslim alındı", "Teslim: eksik/hasar") ve faturayı ("Fatura yok", "Fatura kesildi") gösterir.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Sipariş: kalemleri kataloğunuzla eşleyin'),
      text: t(`${G}.s2.text`, 'Sipariş sekmesinde her ürünün adedi ve tutarı listelenir. "Stoğumda" sütununda "Katalogdan seç" kutusuna en az 2 harf yazıp kendi ürününüzü seçin; yeşil etiket eşlendiğini gösterir, etiketteki çarpı eşlemeyi kaldırır.'),
      tips: [
        t(`${G}.s2.tip1`, 'Eşleme serbesttir; satıcı sevk etmeden de yapılabilir. Yalnız eşlenen kalemler faturada stoğa girer.'),
        t(`${G}.s2.tip2`, 'Satıcı irsaliye kestiyse irsaliye ve kargo numarası toplamın altında görünür.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Teslim: gelen ve hasarlı miktarı yazın'),
      text: t(`${G}.s3.text`, 'Satıcı sevk ettikten (irsaliye geldikten) sonra Teslim sekmesinde ürünleri kontrol edin. Her şey tamsa "Hepsini eksiksiz ve sağlam aldım" işaretli kalsın; değilse satırda Gelen ve Hasarlı miktarı ve Sebebi yazın, isterseniz not ekleyin, sonra "Teslimi onayla"ya basın.'),
      tips: [
        t(`${G}.s3.tip1`, 'Bu adım fatura kesmez ve stoğa giriş yapmaz; yalnız mal kabul kaydı oluşur ve satıcı tarafında da sipariş "Teslim Edildi" olur.'),
        t(`${G}.s3.tip2`, 'Gelen miktar sipariş miktarını, hasarlı miktar gelen miktarı aşamaz.'),
        t(`${G}.s3.tip3`, 'Teslim bir kez onaylanır; sonra yalnız görüntülenir.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Fatura: iki yoldan birini seçin'),
      text: t(`${G}.s4.text`, 'Fatura, satıcı sevk ettikten sonra kesilir. Önerilen yol e-faturadır: satıcı GİB\'e e-fatura gönderir, siz "Gelen e-faturayı al" ile içeri alırsınız (henüz gelmediyse "Gelen kutusuna bak"). Diğer yol "Alış faturası kes"tir: GİB\'e gitmez, yalnız kendi panelinizde muhasebe kaydı oluşur ve e-faturanın yerine geçmez.'),
      tips: [
        t(`${G}.s4.tip1`, 'İptal edilmiş sipariş faturalaştırılamaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s5.title`, '5. Alış faturasına çevirin: depo ve eşleşmeyenler'),
      text: t(`${G}.s5.text`, '"Alış faturası kes" açılan pencerede stoğun gireceği Depoyu seçin. Eşleşmeyen kalem varsa iki seçenekten birini işaretlemeden "Faturalaştır" açılmaz: katalogda yeni ürün oluşturup stok girişi yapmak ya da stoksuz devam edip kalemleri faturaya manuel satır olarak eklemek.'),
      tips: [
        t(`${G}.s5.tip1`, 'Sonuç: eşleşen ürünler seçilen depoya stok girişi olarak girer, tedarikçi carisine borç yazılır; kasa ve banka değişmez. Tedarikçi carisi yoksa satıcı firma bilgileriyle otomatik açılır.'),
        t(`${G}.s5.tip2`, 'Faturaya sipariş miktarları ve satıcının KDV dahil fiyatları yazılır; teslimde girdiğiniz eksik/hasar miktarı faturayı değiştirmez.'),
        t(`${G}.s5.tip3`, '"Vazgeç ve kalemleri elle eşle" ile geri dönüp Sipariş sekmesinde eşleme yapabilirsiniz.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s6.title`, '6. Faturadan sonra eksik stok girişini tamamlayın'),
      text: t(`${G}.s6.text`, 'Fatura kesildiyse ve bazı kalemler stoğa girmediyse Sipariş sekmesinde o kalemde "Stok girilmedi" yazar. Oradan katalogdan ürün seçin ya da "Yeni ürün aç" deyin; o kalem için seçili depoya bir kez stok girişi yapılır. Pencereyi "Kapat" ile kapatırsınız; başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
